export const STATUS_PLAYING = "audioPlaying"
export const STATUS_PAUSED = "audioPaused"
export const STATUS_FINISHED = "audioFinished"